import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { OfferBanner } from "./index";

const parseCustomDate = (dateStr, isEndOfDay) => {
  if (!dateStr) return null;
  const match = String(dateStr).trim().match(/^(\d{2})[-/](\d{2})[-/](\d{4})(?:\s+(\d{1,2}):(\d{2}):(\d{2}))?/);
  if (match) {
    let [_, d, m, y, h, min, s] = match;
    h = h ? String(h).padStart(2, '0') : (isEndOfDay ? "23" : "00");
    min = min ? String(min).padStart(2, '0') : (isEndOfDay ? "59" : "00");
    s = s ? String(s).padStart(2, '0') : (isEndOfDay ? "59" : "00");
    
    const isoString = `${y}-${m}-${d}T${h}:${min}:${s}+05:30`;
    return new Date(isoString).getTime();
  }
  let fallbackStr = String(dateStr);
  if (fallbackStr.length <= 10) fallbackStr += isEndOfDay ? "T23:59:59+05:30" : "T00:00:00+05:30";
  return new Date(fallbackStr).getTime();
};

export const OfferBannerWrapper = ({ onVisibilityChange }) => {
  const rootConfig = useSelector((state) => state?.qt?.data?.subscriptionBanner);
  const rawConfig = rootConfig?.banner_settings || rootConfig;

  const config = useMemo(() => {
    if (!rawConfig) return null;
    const parsedConfig = { ...rawConfig };
    
    if (parsedConfig.end_date) {
      parsedConfig.end_timestamp = parseCustomDate(parsedConfig.end_date, true);
    }
    if (parsedConfig.start_date) {
      parsedConfig.start_timestamp = parseCustomDate(parsedConfig.start_date, false);
    }
    
    if (parsedConfig.show_timer !== undefined) {
      parsedConfig.show_timer = String(parsedConfig.show_timer).toLowerCase() === "true";
    }
    
    if (parsedConfig.enable_banner !== undefined) {
      parsedConfig.enable_banner = String(parsedConfig.enable_banner).toLowerCase() === "true";
    } else {
      parsedConfig.enable_banner = true; // Default to true if the key is missing
    }
    
    return parsedConfig;
  }, [rawConfig]);

  React.useEffect(() => {
    if (!config && onVisibilityChange) {
      onVisibilityChange(false);
    }
  }, [config, onVisibilityChange]);

  if (!config) return null;

  return <OfferBanner config={config} onVisibilityChange={onVisibilityChange} />;
};
